import { createFileRoute } from "@tanstack/react-router";
import { IntroductionView } from "@/components/Exercises/PersonalSources/IntroductionView.tsx";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/personal-sources/"
)({
  component: () => <IntroductionView audience="children" />,
  head: () => ({
    meta: [
      {
        title: "Personal Sources of Strength - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "personalSources.title",
    navbar: {
      showTitle: true,
    },
  }),
});
